/**
 * Keyboard-accessible tabs for the worksheet preview.
 *
 * Every panel's content is in the DOM regardless of JS, so the worksheets stay
 * crawlable and the section degrades to a readable stack if this never runs.
 */
class PrmTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
    if (!this.tabs.length) return;

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(i));
      tab.addEventListener('keydown', (event) => {
        const delta = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!delta) return;
        event.preventDefault();
        const next = (i + delta + this.tabs.length) % this.tabs.length;
        this.select(next);
        this.tabs[next].focus();
      });
    });

    this.select(Number(this.dataset.initial || 0));
  }

  select(index) {
    this.tabs.forEach((tab, i) => {
      const on = i === index;
      tab.setAttribute('aria-selected', String(on));
      tab.tabIndex = on ? 0 : -1;
    });
    this.panels.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
  }
}

if (!customElements.get('prm-tabs')) {
  customElements.define('prm-tabs', PrmTabs);
}
